import { Link } from "react-router-dom";
import { LifeBuoy, MessageCircleQuestion, BookOpen, ArrowLeft } from "lucide-react";

export default function HelpCenter() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Help Center</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    Need assistance with ExamsPro? Find quick answers, troubleshooting guides, and ways to contact our support team.
                </p>

                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <LifeBuoy className="w-5 h-5" />
                            <h3 className="font-semibold">Common Topics</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Resetting passwords or PINs</li>
                            <li>� Reconnecting a camera or fingerprint scanner</li>
                            <li>� Scheduling or rescheduling an exam</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <MessageCircleQuestion className="w-5 h-5" />
                            <h3 className="font-semibold">Get Live Support</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Email: support@secureidtechnologies.com</li>
                            <li>� Chat: Available Mon�Fri, 9am�6pm ET</li>
                            <li>� Phone: (786) 776-3664</li>
                        </ul>
                    </div>
                </section>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link to="/support/contact" className="bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition">
                        Contact Support
                    </Link>
                    <Link to="/solutions/examspro" className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition">
                        <ArrowLeft className="w-4 h-4" /> Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
